import { Dispatch } from "redux";
import { LoginService } from "../../services/LoginService";
import { adminapi, fundmanagerapi } from "../../ApiNames";

export const fetchDataSuccess=(data:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchCountryDataSuccess=(countrydata:any) =>({
    type: 'FETCH_COUNTRY_DATA_SUCCESS',
    payload: countrydata,
});
export const fetchdocDataSuccess=(docdata:any) =>({
    type: 'FETCH_DOC_DATA_SUCCESS',
    payload: docdata,
});
export const fetchImageDataSuccess=(imgdata:any) =>({
    type: 'FETCH_IMAGE_DATA_SUCCESS',
    payload: imgdata,
});
export const fetchUpdateDataSuccess=(updatedata:any) =>({
    type: 'FETCH_UPDATE_DATA_SUCCESS',
    payload: updatedata,
});
export const fetchDataViewSuccess=(dataview:any) =>({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: dataview,
});
export const fetchEditDataSuccess=(regdata:any) =>({
    type: 'FETCH_VIEW_DATA__register_SUCCESS',
    payload: regdata,
});

export const fetchFunddata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = fundmanagerapi.dprofile;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
// Countrydata
export const fetchcoundata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = adminapi.adcountry;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchCountryDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//Attachments data
export const fetchDocdata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid,q:5};
            const apiname = fundmanagerapi.viewdocumentdata;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdocDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//To upload image
export const UploadImageData = (fileToUpload: any, uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const apiname = fundmanagerapi.uploadimage;
            if (uid == null) {
                console.error('Error: uid is null or undefined');
                return;
            }
            // Create FormData and append the file
            const formData = new FormData();
            const fileName = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload', fileToUpload, fileName);
            const response = await LoginService.uploadimage(apiname, formData);
            dispatch(fetchImageDataSuccess(response));
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };
};
export const EditData = (company:any,firstname:any,lastname:any,email:any,licenceno:any,licenceexpdate:any,gender:any,
    application_flag:any,phone:any,address:any,country:any,transfercountry:any,transfertype:any,paypal:any,
    website:any,transferlimit:any,resume:any,uid:any) => {
return async (dispatch: Dispatch) => {
  try {
      const payload = {company:company,firstName:firstname,lastName:lastname,email:email,
        licenceno:licenceno,licenceexpdate:licenceexpdate,gender:gender,application_flag:application_flag,phone:phone,address:address,country:country,transfercountry:transfercountry,
      transfertype:transfertype,paypal:paypal,website:website,transferlimit:transferlimit,resume:resume,uid:uid};      
            const apiname = fundmanagerapi.editprofile;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchUpdateDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//Edit Data
export const RegisterData = (company:any,firstname:any,lastname:any,email:any,licenceno:any,licenceexpdate:any,gender:any,
    application_flag:any,phone:any,address:any,country:any,transfercountry:any,transfertype:any,paypal:any,
    website:any,transferlimit:any,resume:any,uid:any) => {
return async (dispatch: Dispatch) => {
  try {
      const payload = {company:company,firstName:firstname,lastName:lastname,email:email,
        licenceno:licenceno,licenceexpdate:licenceexpdate,gender:gender,application_flag:application_flag,phone:phone,address:address,country:country,transfercountry:transfercountry,
      transfertype:transfertype,paypal:paypal,website:website,transferlimit:transferlimit,resume:resume,uid:uid};
            const apiname = fundmanagerapi.editprofile;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchEditDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

//T0 view document
export const viewdata = (did:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { did:did,q:4};
            const apiname = fundmanagerapi.deletedocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
